import { createFilter } from 'react-select';

export const filterOption = createFilter({
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  stringify: (option) => JSON.stringify(option),
});

export const getHasValue = (selectedValueId: string | number) => {
  if (typeof selectedValueId === 'string' && !selectedValueId.trim().length) {
    return false;
  }

  if (typeof selectedValueId === 'number' && selectedValueId === -1) {
    return false;
  }

  return selectedValueId != null;
};
